export function convertStringToArray(str) {
    if(typeof str === 'string') {
        let array = str.slice(1, -1).split(',')
        return array.map(item => item.trim().replace(/^"(.+)"$/, '$1'));
    }
    return []
}

export function convertToISTEpoch(epochTime) {
    const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
    return epochTime + istOffset;
}


// WEBPACK FOOTER //
// ./src/utilities/helper.js